import React, {Component} from 'react';
import {Button, Form, Icon, Input} from 'semantic-ui-react';
import * as XLSX from 'xlsx';
import CatalogImport from '../CatalogImport/CatalogImport';
import FormStyles from '../forms/form.module.css';

const parseDate = value => {
	if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
	if (typeof value === 'number') {
		const parsed = XLSX.SSF.parse_date_code(value);
		if (parsed) return new Date(parsed.y, parsed.m - 1, parsed.d);
	}
	const text = String(value || '').trim();
	if (!text) throw new Error('Fecha requerida');
	const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(text) ? `${text}T00:00:00` : text);
	if (Number.isNaN(date.getTime())) throw new Error('Fecha inválida');
	return date;
};

const parseTunnels = value => {
	if (!String(value || '').trim()) return [];
	const tunnels = String(value).split(/[,;]/).map(item => Number(item.trim()));
	if (tunnels.some(item => !Number.isFinite(item) || item <= 0)) throw new Error('Túneles inválidos');
	return tunnels;
};

class NuevaZona extends Component{
	constructor(props){
		super(props);
		this.state = {
			fecha: '',
			variedad: '',
			sector: '',
			tuneles: [],
			guardando: false,
		};
	}

	handleUserInput = (event, data) => {
		const name = data ? data.name : event.target.name;
		const value = data ? data.value : event.target.value;
		this.setState({[name]: value});
	}

	handleTunnelChange = (index, value) => {
		this.setState(state => ({
			tuneles: state.tuneles.map((tunel, tunnelIndex) => tunnelIndex === index ? value : tunel),
		}));
	}

	addTunnel = () => {
		this.setState(state => ({tuneles: [...state.tuneles, '']}));
	}

	removeTunnel = index => {
		this.setState(state => ({tuneles: state.tuneles.filter((tunel, tunnelIndex) => tunnelIndex !== index)}));
	}

	writeNew = async event => {
		event.preventDefault();
		this.setState({guardando: true});
		try {
			await this.props.newZona({
				fecha: parseDate(this.state.fecha),
				variedad: this.state.variedad.trim().toUpperCase(),
				sector: this.state.sector.trim(),
				tuneles: this.state.tuneles.map(Number),
			});
			this.setState({fecha: '', variedad: '', sector: '', tuneles: []});
			this.props.changeModal(false);
		} finally {
			this.setState({guardando: false});
		}
	}

	render(){
		return(
			<Form className={FormStyles.form} onSubmit={this.writeNew} autoComplete='off'>
				<Form.Field className={FormStyles.fieldRow} required>
					<label className={FormStyles.fieldLabel}>Fecha de plantación</label>
					<div className={FormStyles.fieldContent}>
						<Input fluid type='date' name='fecha' value={this.state.fecha} onChange={this.handleUserInput} required />
					</div>
				</Form.Field>

				<Form.Field className={FormStyles.fieldRow} required>
					<label className={FormStyles.fieldLabel}>Variedad</label>
					<div className={FormStyles.fieldContent}>
						<Input fluid name='variedad' value={this.state.variedad} placeholder='Ej. Zarzamora' onChange={this.handleUserInput} required />
					</div>
				</Form.Field>

				<Form.Field className={FormStyles.fieldRow} required>
					<label className={FormStyles.fieldLabel}>Sector</label>
					<div className={FormStyles.fieldContent}>
						<Input fluid name='sector' value={this.state.sector} placeholder='Ej. 1 o Norte' onChange={this.handleUserInput} required />
					</div>
				</Form.Field>

				<Form.Field className={FormStyles.fieldRow}>
					<label className={FormStyles.fieldLabel}>Túneles</label>
					<div className={FormStyles.fieldContent}>
						<div className={FormStyles.repeatList}>
							{this.state.tuneles.map((tunel, index) =>
								<div className={FormStyles.repeatRow} key={index}>
									<Input fluid type='number' min='0.01' step='0.01' value={tunel} placeholder={`Longitud del túnel ${index + 1} en metros`} onChange={(event, {value}) => this.handleTunnelChange(index, value)} required />
									<Button type='button' basic icon aria-label={`Eliminar túnel ${index + 1}`} onClick={() => this.removeTunnel(index)}><Icon name='trash alternate outline' /></Button>
								</div>
							)}
						</div>
						<Button type='button' basic size='small' onClick={this.addTunnel}><Icon name='plus' />Agregar túnel</Button>
					</div>
				</Form.Field>

				<div className={FormStyles.actions}>
					<CatalogImport
						label='Sectores'
						template='plantilla-sectores.xlsx'
						headers={['Fecha Plantación', 'Variedad', 'Sector', 'Túneles (m, separados por coma)']}
						items={this.props.zonas}
						getKey={item => item.sector}
						mapRow={row => {
							const variedad = String(row[1] || '').trim().toUpperCase();
							const sector = String(row[2] || '').trim();
							if (!variedad || !sector) throw new Error('Datos requeridos');
							return {fecha: parseDate(row[0]), variedad, sector, tuneles: parseTunnels(row[3]), estado: 'Activa'};
						}}
						addItem={item => this.props.newZona(item)}
					/>
					<Button type='button' basic onClick={() => this.props.changeModal(false)}>Cancelar</Button>
					<Button type='submit' positive loading={this.state.guardando} disabled={this.state.guardando}>Agregar</Button>
				</div>
			</Form>
		);
	}
}

export default NuevaZona;
